import { Component, Vue } from 'vue-property-decorator';
import SideNavigation from '@/components/SideNavigation/SideNavigation';

@Component<Partners>({
  components: {
    SideNavigation,
  },
})
export default class Partners extends Vue {
  protected partners: any = [{
    name: 'Warner Music Group',
    text: 'Warner Music Benelux is onderdeel van de warner music group, een van de grootste muziekmaatschappijen in de wereld. onder de warner music group vallen legendarische labels als atlantic, warner brothers, en rhino. deze labels geven muziek uit van artiesten als michael bublé, red hot chili peppers, madonna, led zeppelin en paolo nutini.',
    image: require('@/assets/images/logo-warner-new.png'),
  }, {
    name: 'Lumo Labs',
    text: 'LUMO Labs is a two-year venture builder program that besides providing preseed and seed funding, actively supports entrepreneurs with a "hands on" approach. LUMO labs mission is to facilitate a vibrant ecosystem and stimulate cross-pollination between its emerging technology start-ups, with a clear goal to help sustainable business to impact the world.',
    image: require('@/assets/images/logo-lumo.png'),
  }, {
    name: 'Elastos',
    text: 'Elastos aims to create a new kind of Internet, powered by blockchain technology. On this new Internet, people will be able to own digital assets and generate wealth from them. Today, there is a seemingly infinite supply of digital books, movies, music and games. But people do not necessarily own their digital property.',
    image: require('@/assets/images/logo-elastos.png'),
  }, {
    name: 'Rose Media',
    text: 'At Dutch Rose Media we believe Augmented Reality gives real life a much needed makeover while simultaneously it is helping us make sense of the world around us. We create surprising and magical mobile experiences with Augmented Reality.',
    image: require('@/assets/images/logo-dutchrose.png'),
  }, {
    name: 'Dutch Design Week Eindhoven',
    text: 'Dutch Design Week Eindhoven is the largest design event in Northern Europe and presents work and concepts from more than 2,600 designers to more than 355,000 visitors from home and abroad.',
    image: require('@/assets/images/logo-ddwe.svg'),
  }, {
    name: 'VR CC',
    text: 'Dit is een algemene text over de partner. de echte informatie komt nog.',
    image: require('@/assets/images/logo-vr.png'),
  }, {
    name: 'Copyright Delta',
    text: 'Dit is een algemene text over de partner. de echte informatie komt nog.',
    image: require('@/assets/images/logo-delta.png'),
  },];

  public mounted() {
    //
  }

}
